import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  MultiSelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { DacScenariosRepository } from '@/store/dac-scenarios-state/dac-scenarios-state.repository';
import { of } from 'rxjs';

interface IGetInspectDacScenariosFormObjectProps {
  store: DacScenariosRepository;
  passingModeOptions?: SelectOption[];
}

export function inspectDacScenariosFormObject({ store, passingModeOptions }: IGetInspectDacScenariosFormObjectProps): DynamicForm {
  const nameField: DynamicField<TextFieldProps> = {
    label: 'settings.dacScenarios.form.nom.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable('dto', 'nom'),
    },
  };

  const descriptionField: DynamicField<TextFieldProps> = {
    label: 'settings.dacScenarios.form.description.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable('dto', 'description'),
    },
  };

  const codeField: DynamicField<TextFieldProps> = {
    label: 'settings.dacScenarios.form.code.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable('dto', 'code'),
    },
  };

  const passingModeField: DynamicField<MultiSelectFieldProps> = {
    label: 'settings.dacScenarios.form.passingMode.label',
    variant: FieldVariant.MULTISELECT,
    props: {
      value: store.getObservable('passingModeSelected'),
      options: passingModeOptions,
    },
  };

  const modeEvaluationFinalField: DynamicField<TextFieldProps> = {
    label: 'settings.dacScenarios.form.modeEvaluationFinal.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable('response', 'modeEvaluationFinal.description'),
    },
  };

  return {
    title: 'settings.dacScenarios.inspect.title',
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [nameField, descriptionField],
          },
          {
            fields: [codeField, passingModeField],
          },
          {
            fields: [modeEvaluationFinalField],
          },
        ],
      },
    ],
  };
}
